<template>
  <div class="home-news">
    <div class="content">
      <h1>
        学习进度<router-link to="./" class="more pull-right"
          ><i class="iconfont icon-tuxing margin-left-10"></i
        ></router-link>
      </h1>
      <div class="clearfix"></div>
      <a-spin :spinning="studyRateSpinning">
        <div class="studyRate">
          <div class="row">
            <div class="col-md-6">
              <div class="rate">
                <div class="row">
                  <div class="col-md-4">
                    <div class="icon">
                      <i class="iconfont icon-jiaoxuejihua1"></i>
                    </div>
                    <p>课程</p>
                  </div>
                  <div class="col-md-8" v-if="recentCourse">
                    <div class="des">上次学习的课程是：</div>
                    <div class="rate-course">
                      {{
                        recentCourse.subjectName
                          ? recentCourse.subjectName
                          : "暂未开始学习"
                      }}
                    </div>
                    <div class="chapterName">
                      {{
                        recentCourse.chapterName
                          ? recentCourse.chapterName
                          : "无学习课程记录"
                      }}
                    </div>
                    <button
                      class="rate-btn"
                      :disabled="!recentCourse.chapterName"
                      @click="
                        gotoCourseInfo(
                          recentCourse.subjectId,
                          recentCourse.chapterId,
                          2
                        )
                      "
                    >
                      继续上课
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="rate">
                <div class="row">
                  <div class="col-md-4">
                    <div class="icon">
                      <i class="iconfont icon-buzhizuoye"></i>
                    </div>
                    <p>作业</p>
                  </div>
                  <div class="col-md-8" v-if="recentHomework">
                    <div class="des">上次做的作业是：</div>
                    <div class="rate-course">
                      {{
                        recentHomework.subjectName
                          ? recentHomework.subjectName
                          : "暂未开始做作业"
                      }}
                    </div>
                    <div class="chapterName">
                      {{
                        recentHomework.paperName
                          ? recentHomework.paperName
                          : "无作业记录"
                      }}
                    </div>
                    <button
                      class="rate-btn"
                      :disabled="!recentHomework.paperName"
                      @click="
                        gotoCourseInfo(
                          recentHomework.subjectId,
                          recentHomework.chapterId,
                          1
                        )
                      "
                    >
                      继续做作业
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  name: "StudyRate",
  data: function () {
    return {
      recentCourse: null,
      recentHomework: null,
      studyRateSpinning: true,
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.getAllData().then((res) => {
        if (res[0].success) {
          if (this.recentHomework) {
            this.studyRateSpinning = false;
          }
          this.recentCourse = res[0].result ? res[0].result : {};
        }
        if (res[1].success) {
          if (this.recentCourse) {
            this.studyRateSpinning = false;
          }
          this.recentHomework = res[1].result ? res[1].result : {};
        }
      });
    } else {
      this.common.toURL("/login");
    }
  },
  methods: {
    changeActive: function ($event) {
      $event.currentTarget.getElementById("imgnewsin").className =
        "imgnewsin active";
    },
    removeActive: function ($event) {
      $event.currentTarget.className = "row newul";
    },
    // getAllData使用了promise.all同时读取了两个接口的数据统一处理
    getAllData() {
      return Promise.all([
        this.axios.get(`/biz/subject/recent/study`),
        this.axios.get(`/biz/subject/recent/homework`),
      ]);
    },
    gotoCourseInfo(viewCode, chapterId, type) {
      const url =
        type === 1
          ? `/biz/subject/url?subjectCode=${viewCode}&viewCode=&chapterId=${chapterId}&type=${type}`
          : `/biz/subject/url?subjectCode=${viewCode}&viewCode=&chapterId=${chapterId}`;
      this.axios.get(url).then((res) => {
        if (res.code === 200 && res.result !== null) {
          window.open(res.result);
          return;
        } else if (res.code === 200 && res.message === "9002") {
          this.$message.error("非网络学习课程!");
          return;
        } else if (res.code === 200 && res.message === "1000") {
          this.$message.error("未缴费不能学习!");

          this.$router.push("/mypersonal/tuitionfeethis");
          return;
        } else if (res.code === 200 && res.message === "2202") {
          this.$message.error("该课程未缴费不能学习!");
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && res.message === "2201") {
          this.$message.error("您还未缴费不能学习!");
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && res.message === "3000") {
          this.$message.error("不在学习时间范围!");
          return;
        } else if (res.code === 200 && res.message === "9000") {
          this.$message.error("非教学计划内课程!");
          return;
        } else if (res.code === 200 && res.message === "9999") {
          this.$message.error("已毕业不允许学习!");
          return;
        } else if (res.code === 200 && res.message === "9001") {
          this.$message.error("课程建设中，暂不能访问!");
          return;
        } else if (res.code === 200 && res.message === "9004") {
          this.$message.error("未配置学习时间!");
          return;
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.home-news {
  padding: 16px 0;

  .content {
    margin: 0 auto;

    h1 {
      font-size: 18px;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 16px;

      .english {
        color: #999;
        font-size: 14px;
        font-weight: normal;
        text-transform: Uppercase;
      }
    }
  }
}

.more {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}

.studyRate {
  background: #fff;
  padding: 16px;
  height: 150px;
}

.rate {
  text-align: center;

  .col-md-8 {
    text-align: left;
    position: relative;
  }

  p {
    margin-top: 10px;
    color: #666;
    margin-left: 8px;
  }

  .rate-course {
    font-size: 18px;
    margin-bottom: 10px;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .rate-chapter {
    font-size: 11px;
    margin-bottom: 10px;
    text-align: left;
    color: #999;
    ellipsis2();
  }

  .des {
    color: #999;
    margin-bottom: 10px;
  }

  .rate-btn {
    display: inline-block;
    width: 104px;
    height: 34px;
    line-height: 34px;
    background: $bgColor;
    color: #fff;
    border-radius: 17px;
    position: absolute;
    bottom: -10px;
    left: 15px;
    cursor: pointer
  }
}
.rate i {
  display: inline-block;
  width: 80px;
  font-size: 36px;
  height: 80px;
  background: #f6ad3b;
  color: #fff;
  line-height: 80px;
  border-radius: 40px;

  &.icon-buzhizuoye {
    color: #f2f8fd;
  }
}

.icon {
  border: 1px dashed #c7c9cb;
  padding: 5px;
  width: 90px;
  height: 90px;
  border-radius: 45px;
}

.chapterName {
  font-size: 13px;
  color: #999;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
}

.disabled {
  background: #ccd1cf !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/StudyRate.vue